// universe.actions.ts
import { Action } from '@ngrx/store';
import { Contact } from '../models/contact.model';

export const FETCH = '[App] FETCH';
export const SET_PAGE = '[App] SET_PAGE';
export const RESET = '[App] RESET';
export const SEND_CONTACT_MESSAGE = '[App] SEND_CONTACT_MESSAGE';
export const SEND_CONTACT_MESSAGE_SUCCESS = '[App] SEND_CONTACT_MESSAGE_SUCCESS';
export const SEND_CONTACT_MESSAGE_FAILURE = '[App] SEND_CONTACT_MESSAGE_FAILURE';

export class Fetch implements Action {
  readonly type = FETCH;
  constructor() {}
}

export class SetPage implements Action {
  readonly type = SET_PAGE;
  constructor(public payload: string) { }
}

export class Reset implements Action {
  readonly type = RESET;
  constructor() {}
}

export class SendContactMessage implements Action {
  readonly type = SEND_CONTACT_MESSAGE;
  constructor(public payload: Contact) { }
}

export class SendContactMessageSuccess implements Action {
  readonly type = SEND_CONTACT_MESSAGE_SUCCESS;
  constructor(public payload: any) { }
}

export class SendContactMessageFailure implements Action {
  readonly type = SEND_CONTACT_MESSAGE_FAILURE;
  constructor(public payload: any) { }
}

export type Actions = Fetch | SetPage | Reset | SendContactMessage | SendContactMessageSuccess | SendContactMessageFailure;



// WEBPACK FOOTER //
// ./src/actions/app.actions.ts